<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
    >
        <path
            d="M6.77777 5.77777C8.15848 5.77777 9.27777 4.65848 9.27777 3.27777C9.27777 1.89706 8.15848 0.777771 6.77777 0.777771C5.39706 0.777771 4.27777 1.89706 4.27777 3.27777C4.27777 4.65848 5.39706 5.77777 6.77777 5.77777Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.4811 5.62222C11.7478 5.71888 12.0333 5.77777 12.3333 5.77777C13.7144 5.77777 14.8333 4.65888 14.8333 3.27777C14.8333 1.89666 13.7144 0.777771 12.3333 0.777771C12.0333 0.777771 11.7478 0.835549 11.4811 0.933327"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.2878 10.5478C10.1711 9.32332 8.56555 8.55554 6.77777 8.55554C4.39444 8.55554 2.33333 9.9211 1.32666 11.9111C0.882217 12.79 1.35777 13.8633 2.28888 14.1867C3.43444 14.5844 4.96444 14.9455 6.77777 14.9455C7.73555 14.9455 8.60777 14.8422 9.39111 14.6889"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.7711 13.2778L13.5589 14.9444L17.3333 9.94443"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
